import LeagueFilter from "@/components/LichThiDauFull/LeagueFilter";

export default function LeagueFilterV26({
  leagues = [],
  selectedIds,
  onToggle,
  onClear,
  themeStyle,
  loading = false,
}) {
  return (
    <div className="kbv-ltd-full kbv-v26-league-filter">
      <LeagueFilter
        leagues={leagues}
        selectedIds={selectedIds}
        onToggle={onToggle}
        onClear={onClear}
        themeStyle={themeStyle}
        loading={loading}
      />
    </div>
  );
}
